export const troubleshootingHoldOption = { name: 'Troubleshooting hold', id: 'troubleshooting_hold' };
